import Card from '@pelckmans/elementis/components/card';
import Results from '@pelckmans/elementis/components/results';
import { useTranslation } from 'react-i18next';
import { ExerciseCategory } from '../../../../api/exercise-category';
import SublevelSummary from '../../../../components/module/SublevelSummary';
import { getResultPercentages } from '../../../../utils/results';
import { useCategoryLinkBuilder } from '../hooks/useCategoryLinkBuilder';

function ExerciseCategoryCard({ exerciseCategory }: { exerciseCategory: ExerciseCategory }) {
  const { t } = useTranslation();
  const { buildCategoryLink } = useCategoryLinkBuilder();

  return (
    <Card
      key={exerciseCategory.id}
      as="link"
      href={buildCategoryLink(exerciseCategory.id)}
      titleTag="h3"
      titleText={exerciseCategory.name}
      tags={{
        role: 'group',
        'aria-label': t('PAGES.VEM.CARDS.SUBLEVEL_SUMMARY.A11Y_LABEL'),
        children: (
          <SublevelSummary
            sublevels={exerciseCategory.categories}
            totalExercises={exerciseCategory.totalExercises}
            completedExercises={exerciseCategory.completedExercises}
            contentTypeSummary={exerciseCategory.contentTypeSummary}
          />
        ),
      }}
      results={
        (exerciseCategory.score?.maximum || 0) > 0 ? (
          <Results quantifiable {...getResultPercentages(exerciseCategory.score)} />
        ) : undefined
      }
    />
  );
}

export default ExerciseCategoryCard;
